import React from 'react';

interface Choice {
  label: string;
  value: string;
}

interface AnswerInputProps {
  type: string;
  choices?: Choice[];
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

export const AnswerInput: React.FC<AnswerInputProps> = ({
  type,
  choices,
  value,
  onChange,
  onSubmit,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && value.trim()) {
      onSubmit();
    }
  };

  if (type === 'multiple_choice' && choices) {
    return (
      <div className="answer-input answer-input-mc">
        {choices.map((choice) => (
          <button
            key={choice.value}
            className={`choice-button ${value === choice.value ? 'selected' : ''}`}
            onClick={() => onChange(choice.value)}
          >
            <span className="choice-label">{choice.label}</span>
          </button>
        ))}
      </div>
    );
  }

  if (type === 'numeric') {
    return (
      <div className="answer-input answer-input-numeric">
        <input
          type="text"
          inputMode="decimal"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter your answer..."
          autoFocus
        />
      </div>
    );
  }

  if (type === 'expression') {
    return (
      <div className="answer-input answer-input-expression">
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter expression (e.g., 2x + 3)..."
          autoFocus
        />
      </div>
    );
  }

  // Default: short text
  return (
    <div className="answer-input answer-input-text">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="Enter your answer..."
        autoFocus
      />
    </div>
  );
};
